import { combineReducers } from 'redux';

import configReducer from './configReducer';
import languageReducer from './languageReducer';

export default combineReducers({
    config: configReducer,
    lang: languageReducer,
});
